import { render, staticRenderFns } from "./ListRegistrationPage.vue?vue&type=template&id=588e8eb2&"
import script from "./ListRegistrationPage.vue?vue&type=script&lang=js&"
export * from "./ListRegistrationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports